export const ANOMALY_KINDS = {
  AXIAL_CRACK: "Axial Crack",
  CIRCUMFERENTIAL_CRACK: "Circumferential Crack",
  LOCAL_LEACHING_OUT: "Local Leaching Out",
  LOCAL_LEACHING_IN: "Local Leaching In",
  CLAMP: "Clamp",
  LEACHING: "Leaching",
  RADIAL_CRACK: "Radial Crack",
  APPD_TAKEOFF: "Appd_TakeOff",
  DELAMINATION: "Delamination",
  DIRT: "Dirt",
  GAS: "Gas",
  WIRE_BREAK: "Wire Break",
  CASING_TUBE: "Casing Tube",
  H2S: "H2S",
  UNKNOWN_ANOMALY: "Unknown Anomaly",
  MISSING_WALL: "Missing Wall",
  INCREASE_MFW: "Increase MFW",
  OTHER: "Other",
  AIR_VENT: "Air vent",
  MISSING_FW: "Missing FW",
  MISSING_BW: "Missing BW",
  CORROSION: "Corrosion",
  CORROSION_INSIDE: "Corrosion inside",
  CORROSION_OUTSIDE: "Corrosion outside",
  CORROSION_PRODUCT: "Corrosion product",
  OVAL: "Oval",
  GREASE: "Grease",
  LEAKAGE: "Leakage",
  DAMAGED_CEMENT: "Damaged cement",
  MISSING_CEMENT: "Missing cement",
  DAMAGED_COATING: "Damaged coating",
  MISSING_COATING: "Missing coating",
  DAMAGED_LINER: "Damaged liner",
  MISSING_LINER: "Missing liner",
  REDUCED_WALL_THICKNESS: "Reduced Wall Thickness",
  DENT: "Dent",
  POSSIBLE_LEAKAGE: "Possible Leakage",
  CREASING: "Creasing",
  DAMAGED_WALL_INSIDE: "Damaged wall inside",
  DAMAGED_WALL_OUTSIDE: "Damaged wall outside",
  SCALING: "Scaling",
} as const;
